// Hook do pobierania listy klientów handlowca (wyszukiwarka) – GET /sales-crm/clients?search_keyword=...

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IResponse as IClientResponse } from 'api/endpoints/useGetClient';

/** Element listy klientów (alias dla kompatybilności z widokiem) */
export type ITraderClient = IClientResponse;

/** Odpowiedź API listy klientów handlowca */
export interface ITraderClientsResponse {
  items: ITraderClient[];
  total_count: number;
  total_pages: number;
}

const getTraderClients = (searchKeyword: string): Promise<ITraderClientsResponse> =>
  axios.get('/sales-crm/clients', {
    params: { search_keyword: searchKeyword || undefined }
  });

export const useGetTraderClients = (
  searchKeyword: string,
  options?: UseQueryOptions<ITraderClientsResponse, IError>
) =>
  useQuery<ITraderClientsResponse, IError>(
    ['sales-crm', 'clients', searchKeyword],
    () => getTraderClients(searchKeyword),
    {
      ...options,
      enabled: (options?.enabled !== false) && searchKeyword.trim().length > 0
    }
  );
